// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dGa2S9BhqJ {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.dGa2S9BhqJ h4 {
  line-height: 3em;
}
.dGa2S9BhqJ .vYsycYad3k {
  float: left;
  width: 100%;
}
.dGa2S9BhqJ .LSX9YDybQY {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.dGa2S9BhqJ .LSX9YDybQY:hover {
  cursor: pointer;
}
.dGa2S9BhqJ .LSX9YDybQY:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.aFTfBN8knJ .NES2ARHNuM:focus {
  outline: none;
}
.aFTfBN8knJ .NES2ARHNuM.ZJRBqpizyF.z3VVu3JYuQ {
  background: #375A88;
}
.aFTfBN8knJ .NES2ARHNuM.ZJRBqpizyF.z3VVu3JYuQ span {
  color: #fff;
}
.aFTfBN8knJ .z3VVu3JYuQ {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.aFTfBN8knJ .z3VVu3JYuQ:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.aFTfBN8knJ input {
  height: 38px;
  min-width: 220px;
}
.LSX9YDybQY.nrKFd6gdbc {
  background: #410102;
}
.LSX9YDybQY.dOYHboa9KD {
  background: #911318;
}
.LSX9YDybQY.xSsYC_AZhd {
  background: #D8293B;
}
.LSX9YDybQY.m4M6mMdJtx {
  background: #F2373C;
}
.LSX9YDybQY.l3nrn9MgW9 {
  background: #FC4448;
}
.LSX9YDybQY.zGDlxeIwB1 {
  background: #ED535E;
}
.LSX9YDybQY.WXDuSeTwXA {
  background: #E34926;
}
.LSX9YDybQY.ScclWnSYDz {
  background: #FC562B;
}
.LSX9YDybQY.jpUu5Cc10U {
  background: #FC6722;
}
.LSX9YDybQY.ZdlQ7VSjxf {
  background: #FD7F24;
}
.LSX9YDybQY._V3VKiUBJ8 {
  background: #FD8D26;
}
.LSX9YDybQY.wqC9nrygg0 {
  background: #EC9C3E;
}
.LSX9YDybQY.SMZntJGKvX {
  background: #0e673a;
}
.LSX9YDybQY.xXd2e45Got {
  background: #208740;
}
.LSX9YDybQY.MWObLBd9cf {
  background: #239718;
}
.LSX9YDybQY._66iBIdJzd {
  background: #55A84D;
}
.LSX9YDybQY.q9zGEG9wPh {
  background: #4BBE5A;
}
.LSX9YDybQY.K0z5LhAByb {
  background: #0CCA6A;
}
.LSX9YDybQY.z0Wb1fawRN {
  background: #0A3C64;
}
.LSX9YDybQY.Bt1GhK5S3n {
  background: #0d487a;
}
.LSX9YDybQY.DarTO78_uh {
  background: #10538d;
}
.LSX9YDybQY.R3bU65ElvW {
  background: #115A99;
}
.LSX9YDybQY.CwOsgrCdTD {
  background: #3387E2;
}
.LSX9YDybQY.smewXaoxcO {
  background: #1BA9CF;
}
.LSX9YDybQY.Q5vyCjaO7F {
  background: #d27c02;
}
.LSX9YDybQY.U66J_GEJTt {
  background: #fb9402;
}
.LSX9YDybQY.wFHHWKKUJT {
  background: #FD9B30;
}
.LSX9YDybQY.l7APC95Aj_ {
  background: #FDBE2D;
}
.LSX9YDybQY.iXQSbEkOtP {
  background: #FED831;
}
.LSX9YDybQY.KUAsqOxrQH {
  background: #FFFD38;
}
.LSX9YDybQY.c5pftd4f9P {
  background: #2D215C;
}
.LSX9YDybQY.F3IoeX5bl0 {
  background: #483C83;
}
.LSX9YDybQY.QUQRKnjeIH {
  background: #58518d;
}
.LSX9YDybQY.gEgWfGk7zJ {
  background: #7068A9;
}
.LSX9YDybQY.DwVpcs9OCp {
  background: #7f78b2;
}
.LSX9YDybQY.E7uyRL2Kk4 {
  background: #8f88bc;
}
.LSX9YDybQY.TC7x0JaXGu {
  background: #000;
}
.LSX9YDybQY.D2VQLOUIoi {
  background: #282626;
}
.LSX9YDybQY.l6bZ1W9NMB {
  background: #242222;
}
.LSX9YDybQY.j9X_pBcORi {
  background: #353838;
}
.LSX9YDybQY.lc_hv5KQV3 {
  background: #666;
}
.LSX9YDybQY.mMCW8uWwLK {
  background: #999;
}
.oRmxT63CWd {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.oRmxT63CWd .sCsV9y_LZo {
  display: none;
}
.hVY6sOglzo {
  font-size: 11px;
}
.hVY6sOglzo .Wt8n4g3Azp {
  display: flex;
}
.hVY6sOglzo .Wt8n4g3Azp .OcaAtyHAKF {
  font-size: 11px;
  font-weight: 300;
  margin-bottom: 0px;
  margin-right: 4px;
  white-space: nowrap;
}
.hVY6sOglzo .Wt8n4g3Azp .LLNB1xnc4u {
  margin: 0px;
}
.hVY6sOglzo .Zdw244HFAE {
  display: flex;
  justify-content: flex-start;
}
.hVY6sOglzo .Zdw244HFAE .OcaAtyHAKF {
  font-size: 11px;
}
.hVY6sOglzo .rq2M3FPLlg {
  display: flex;
  align-items: center;
  margin-left: 12px;
}
.hVY6sOglzo .rq2M3FPLlg .djyVVAT_r_ {
  margin-right: 4px;
}
.hVY6sOglzo .rq2M3FPLlg .z9smCx3paQ {
  margin-bottom: 4px;
}
.c8f7ew2kzh {
  margin: 0px;
  text-transform: capitalize;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `dGa2S9BhqJ`,
	"color-row": `vYsycYad3k`,
	"color-tile": `LSX9YDybQY`,
	"picker-component": `aFTfBN8knJ`,
	"picker-element": `NES2ARHNuM`,
	"active": `ZJRBqpizyF`,
	"btn": `z3VVu3JYuQ`,
	"red-1": `nrKFd6gdbc`,
	"red-2": `dOYHboa9KD`,
	"red-3": `xSsYC_AZhd`,
	"red-4": `m4M6mMdJtx`,
	"red-5": `l3nrn9MgW9`,
	"red-6": `zGDlxeIwB1`,
	"orange-1": `WXDuSeTwXA`,
	"orange-2": `ScclWnSYDz`,
	"orange-3": `jpUu5Cc10U`,
	"orange-4": `ZdlQ7VSjxf`,
	"orange-5": `_V3VKiUBJ8`,
	"orange-6": `wqC9nrygg0`,
	"green-1": `SMZntJGKvX`,
	"green-2": `xXd2e45Got`,
	"green-3": `MWObLBd9cf`,
	"green-4": `_66iBIdJzd`,
	"green-5": `q9zGEG9wPh`,
	"green-6": `K0z5LhAByb`,
	"blue-1": `z0Wb1fawRN`,
	"blue-2": `Bt1GhK5S3n`,
	"blue-3": `DarTO78_uh`,
	"blue-4": `R3bU65ElvW`,
	"blue-5": `CwOsgrCdTD`,
	"blue-6": `smewXaoxcO`,
	"yellow-1": `Q5vyCjaO7F`,
	"yellow-2": `U66J_GEJTt`,
	"yellow-3": `wFHHWKKUJT`,
	"yellow-4": `l7APC95Aj_`,
	"yellow-5": `iXQSbEkOtP`,
	"yellow-6": `KUAsqOxrQH`,
	"purple-1": `c5pftd4f9P`,
	"purple-2": `F3IoeX5bl0`,
	"purple-3": `QUQRKnjeIH`,
	"purple-4": `gEgWfGk7zJ`,
	"purple-5": `DwVpcs9OCp`,
	"purple-6": `E7uyRL2Kk4`,
	"black-1": `TC7x0JaXGu`,
	"black-2": `D2VQLOUIoi`,
	"black-3": `l6bZ1W9NMB`,
	"black-4": `j9X_pBcORi`,
	"black-5": `lc_hv5KQV3`,
	"black-6": `mMCW8uWwLK`,
	"picker-theme": `oRmxT63CWd`,
	"arrow-regular": `sCsV9y_LZo`,
	"linked-tasked__tooltip": `hVY6sOglzo`,
	"linked-tasked__tooltip--content": `Wt8n4g3Azp`,
	"content--label": `OcaAtyHAKF`,
	"content--text": `LLNB1xnc4u`,
	"linked-task__assigned-users": `Zdw244HFAE`,
	"linked-task__assigned-users--avatars": `rq2M3FPLlg`,
	"avatars--img": `djyVVAT_r_`,
	"avatar--more": `z9smCx3paQ`,
	"linked-tasked__tooltip--project-title": `c8f7ew2kzh`
};
export default ___CSS_LOADER_EXPORT___;
